var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "7.5rem",
    width: "7.5rem",
    x: 0,
    y: 0,
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            @keyframes rotate {\n                from {transform: rotate(105deg);}\n                to {transform: rotate(465deg);}\n            }\n            .rotating {\n                animation-name: rotate;\n                animation-duration: 1200ms;\n                animation-iteration-count: infinite;\n                animation-timing-function: cubic-bezier(1, 1, 1, 1);\n                transform-origin: 300px 300px;\n            }\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient1",
    gradientTransform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgba(var(--accentColor), 1)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(var(--accentColor), 0.5)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient2",
    gradientTransform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgba(var(--accentColor), 0.1)",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "rgba(var(--accentColor), 0.3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(var(--accentColor), 0.5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Pattern",
    x: 0,
    y: 0,
    width: 600,
    height: 600,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0, 300, 300)"
  }, /*#__PURE__*/React.createElement("rect", {
    shapeRendering: "crispEdges",
    x: 0,
    y: 0,
    width: 300,
    height: 600,
    fill: "url(#Gradient1)"
  }), /*#__PURE__*/React.createElement("rect", {
    shapeRendering: "crispEdges",
    x: 300,
    y: 0,
    width: 300,
    height: 600,
    fill: "url(#Gradient2)"
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "rotating",
    style: {
      stroke: "url(#Pattern)"
    },
    fill: "transparent",
    transform: "rotate(105, 300, 300)",
    strokeWidth: 60,
    d: "M 364 58 A 250 250 0 1 1 235 58"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.fbf384290b67e89d919165a440d12026.svg";
export { ForwardRef as ReactComponent };